export default __webpack_public_path__ + "static/media/pt_same_articles.910fb7be.png";